export const gradientColor = '#f6bd60';
